class SectionInstagram {
    // 1. describe and create/initiate our object
    constructor() {
        this.instagramWrapper = document.querySelector('.section-instagram__images-wrapper');
        this.images = document.querySelectorAll('.section-instagram__image-wrapper');
        this.isVisible = false;
        this.translateValues = Array.from(this.images).map(() => 0);
        this.translateFactor = 2.4;
        this.customFactor = 1.4;
        this.disableParalax = false;
        if (this.instagramWrapper && this.instagramWrapper) {
            this.events();
        }
    }

    // 2. events
    events() {
        document.addEventListener("scroll", () => {
            this.observeSection();
        })
    }

    // 3. methods (function, action...)
    observeSection() {
        const options = {
            root: null,
            rootMargin: '-20px',
            threshold: 0.3,
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.isVisible = true;
                    this.instaParallax();
                    observer.unobserve(entry.target);
                } else {
                    this.isVisible = false;
                }
            });
        }, options);

        observer.observe(this.instagramWrapper);
    }

    // Funkcja do obsługi efektu paralaksy
    instaParallax() {
        if (window.innerWidth < 768) {
            this.disableParalax = true;
        }
        if (this.disableParalax == false) {
            const scrollY = window.scrollY;
            const scrollDirection = scrollY > this.lastScrollY ? 'down' : 'up';
            this.images.forEach((element, index) => {
                let baseTransform = parseInt(element.dataset.baseTransform) || 0;
                const transformStyle = window.getComputedStyle(element).getPropertyValue('transform');
                const translateY = parseInt(transformStyle.split(',')[5]);
                let offsetMax;
                let customOffset
                if (window.innerWidth >= 768) {
                    offsetMax = -baseTransform;
                    customOffset = 69;
                }

                //Zachowanie elementów parallax dla ujemnych wartości data-base-transform
                if (this.disableParallax == false) {

                }
                if (this.isVisible && baseTransform < 0 && baseTransform <= offsetMax) {
                    if (scrollDirection === 'down') {
                        if (this.translateValues[index] < offsetMax) {
                            this.translateValues[index] += this.translateFactor;
                        }
                    } else {
                        if (this.translateValues[index] > baseTransform) {
                            this.translateValues[index] -= this.translateFactor;
                        }
                    }
                    element.style.transform = `translateY(${this.translateValues[index]}px)`;
                }
                //Zachowanie elementów parallax dla dodatnich wartości data-base-transform
                if (this.isVisible && baseTransform > 0 && baseTransform >= offsetMax) {
                    if (scrollDirection === 'up') {
                        if (this.translateValues[index] > offsetMax) {
                            this.translateValues[index] -= this.translateFactor;
                        }
                    } else {
                        if (this.translateValues[index] < baseTransform) {
                            this.translateValues[index] += this.translateFactor;
                        }
                    }
                    element.style.transform = `translateY(${-this.translateValues[index]}px)`;
                }
                //Zachowanie elementów parallax dla zerowych wartości data-base-transform
                if (this.isVisible && baseTransform == 0) {
                    if (scrollDirection === 'down') {
                        if (this.translateValues[index] < customOffset) {
                            this.translateValues[index] += this.customFactor;
                        }
                    } else {
                        if (this.translateValues[index] > baseTransform) {
                            this.translateValues[index] -= this.customFactor;
                        }
                    }
                    if (index == 0) {
                        element.style.transform = `translateY(${-this.translateValues[index]}px)`;
                    }
                    else if (index == 3) {
                        element.style.transform = `translateY(${this.translateValues[index]}px)`;
                    }
                }

            });
            this.lastScrollY = scrollY;
        }
    }
}

export default SectionInstagram;
